import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
// import { eventsThisMonth } from '../../test.data';
import Button from '../button/v2/button';
import DropdownButton, { DROPDOWN_MENU } from '../button/v2/dropdown.button';
import { getEventsDropdownOptions } from './utils/getOptions';
import { v4 as uuid4 } from 'uuid';

export function EventsOptionsDropdown({ id }: { id: string }) {
  // const event = eventsThisMonth.find((event) => event.id === id);

  const options = getEventsDropdownOptions();
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="mobile:hidden tablet-lg:block">
        <Button color="glass" size="sm" asIcon="dots" withButtonStyle />
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        sideOffset={0}
        align="center"
        className="bg-[#121212] py-2 px-1 rounded-lg shadow-feed"
      >
        {options.map(({ icon, text }) => (
          <DropdownMenu.Item key={uuid4()} className={DROPDOWN_MENU.item}>
            <DropdownButton icon={icon} text={text} />
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
